import { api } from '@cwd/lib/main';

export type DataSourceListItem = {
    DataSourceId: string;
    Name: string;
    VariableName: string;
    Url: string;
    Type: number;
    Modified: string;
};

export type DataSourceSaveModel = {
    DataSourceId: string | null;
    Name: string;
    VariableName: string;
    Url: string;
    Type: number;
};

export type ValidateUrlResult = {
    Status: 'OK' | 'Error';
    Message?: string;
    Time?: number;
};

export async function getDataSources(): Promise<DataSourceListItem[]> {
    return api.get(`/DataSources?$filter=Type+eq+'RSS'+or+Type+eq+'Feed20'`);
}

export async function saveDataSource(dataSource: DataSourceSaveModel): Promise<DataSourceListItem> {
    return api.post('/DataSources', dataSource);
}

export async function validateDataSourceUrl(url: string): Promise<ValidateUrlResult> {
    return api.get('/DataSources/Validate?url=' + encodeURIComponent(url));
}

export async function previewDataSource(variableName: string): Promise<any> {
    return api.get('/Issues/PreviewDataSource?variableName=' + variableName);
}
